import styled from 'styled-components';

export const DropdownPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  max-height: 480px;
  background: #fff;
  border-radius: 8px;
  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.12),
    0 3px 6px rgba(0, 0, 0, 0.08);
`;

export const PanelHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #f0f0f0;
`;

export const ColumnList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;

    &:hover {
      background: #999;
    }
  }
`;

export const PanelTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const ResetLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  color: #fa8c16;

  &:hover {
    color: #d46b08;
  }
`;

export const SearchWrapper = styled.div`
  flex-shrink: 0;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
`;

export const GroupLabel = styled.div`
  padding: 10px 16px 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fa8c16;
  letter-spacing: 0.5px;
`;

export const ColumnRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #333;

  &:hover {
    background: #fafafa;
  }
`;
